import { __exports as faCircle } from "../../../_virtual/faCircle.es2.js";
var hasRequiredFaCircle;
function requireFaCircle() {
  if (hasRequiredFaCircle) return faCircle;
  hasRequiredFaCircle = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "fas";
    var iconName = "circle";
    var width = 512;
    var height = 512;
    var aliases = [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915];
    var unicode = "f111";
    var svgPathData = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faCircle = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  })(faCircle);
  return faCircle;
}
export {
  requireFaCircle as __require
};
//# sourceMappingURL=faCircle.es.js.map
